export default __webpack_public_path__ + "static/media/hotel02.e098435b.png";